





























import { Component, Vue } from "@/shared/vuepack";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import moment from "moment-timezone";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { HsabExpenseResponse, RelationshipType, TransferSchedule } from "@/shared/types";
import * as transferScheduleUtility from "@/employee/Utilities/TransferScheduleUtility";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: { GenericLoadingSpinner }
})
export default class HsabExpenseCardRowSchedule extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  get schedule (): TransferSchedule {
    if (this.expense) {
      return this.expense.schedule;
    }
    return null;
  }

  get formattedStartDate () {
    return moment(this.schedule.scheduleStartDate).format("MMM DD, YYYY");
  }

  get formattedEndDate () {
    if (isNullEmptyOrUndefined(this.schedule.scheduleEndDate)) {
      return "no end date";
    }
    return moment(this.schedule.scheduleEndDate).format("MMM DD, YYYY");
  }

  get formattedConfirmedOnDate () {
    return moment(this.schedule.userConfirmationDate).format("MMM DD, YYYY");
  }

  get scheduleDescription () {
    return transferScheduleUtility.getScheduleDescription(this.schedule);
  }

  get previewDates () {
    return this.hsabExpenseFormStore.generatedCalendarEntries.calendarDates;
  }

  get first10PreviewDates () {
    if (this.nowCst.hours() > 13 && this.hasClonedFromRecurringExpenseToday) {
      return this.previewDates.filter(dateStr => {
        return !this.toCstStartOfDay(dateStr).isSame(this.startOfDayTodayCst, "day");
      }).slice(0, 10);
    }
    return this.previewDates.slice(0, 10);
  }

  get isPreviewLoading () {
    return this.hsabExpenseFormStore.isSchedulePreviewLoading;
  }

  get isPreviewLoaded () {
    return this.hsabExpenseFormStore.isSchedulePreviewLoaded;
  }

  getPreviewDateDisplay (str) {
    return moment(str).format("dddd MMMM Do, YYYY");
  }

  get startOfDayTodayCst (): moment.Moment {
    return moment().tz("America/Chicago").startOf("day");
  }

  get nowCst (): moment.Moment {
    return moment().tz("America/Chicago");
  }

  toCstStartOfDay (date: string): moment.Moment {
    return moment.tz(date, "YYYY-MM-DD", "America/Chicago").startOf("day");
  }

  get hasClonedFromRecurringExpenseToday (): boolean {
    return this.hsabExpenseFormStore.expense &&
        this.hsabExpenseFormStore.expense.relationships &&
        this.hsabExpenseFormStore.expense.relationships.length > 0 &&
        this.hsabExpenseFormStore.expense.relationships.some(x => {
          return x.relationshipType === RelationshipType.ClonedFromRecurringTemplate &&
              x.targetExpense &&
              x.targetExpense.dateOfService &&
              this.toCstStartOfDay(x.targetExpense.dateOfService).isSame(this.startOfDayTodayCst, "day");
        });
  }
}
